<template>
  <div>
    <vx-card class="mb-4">
      <vs-tabs :color="colorx">
        <vs-tab :label="$t('functionality.title')">
          <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
              <validation-observer ref="validator" #default="{valid}">
                <b-form @submit.prevent="createOrUpdate">

                  <validation-provider
                    #default="{ errors }"
                    :name="$t('functionality.name')"
                    rules="required"
                    class="flex-grow"
                    slim>
                    <b-form-group
                      id="input-group-1"
                      :label="$t('functionality.name')"
                      label-for="functionality_name">
                      <b-form-input
                        id="functionality_name"
                        v-model="model.name"
                        :state="errors.length > 0 ? false:null"
                        name="functionality_name"
                        class="required"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                  <!-- -->
                  <b-form-group
                    id="input-group-1"
                    :label="$t('functionality.description')"
                    label-for="functionality_description">
                      <b-form-textarea
                        id="functionality_description"
                        v-model="model.description"
                        rows="4"/>
                  </b-form-group>
                </b-form>
              </validation-observer>
              <!--
              <div class="w-full">
                <label class="vs-input--label">{{ $t('functionality.module') }}</label>
                <select-suggestion
                  class="required"
                  column="id,name"
                  model="Module"
                  v-model="module"
                  :appendClearOption="true"
                  placeholderText="Digite o nome ou id do módulo"/>
              </div>
            -->
            </div>
            <div class="w-full flex gap-2 justify-end">
              <b-button
                v-if="!isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'functionalities.create'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>
              <b-button
                v-if="isEdit()"
                variant="primary"
                :disabled="!validateForm"
                v-permission="'functionalities.edit'"
                @click="createOrUpdate">
                {{ $t('action.save') }}
              </b-button>

              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
              </b-button>
            </div>
          </div>
        </vs-tab>
        <vs-tab :label="$t('actions')" v-if="isEdit()">

          <div class="vx-row mb-6" style="padding-top: 30px">
            <div class="vx-col w-full">
              <b-button
                @click="showPopupPermission = true"
                variant="primary"
                icon="add">
                {{ $t('adicionar') }}
              </b-button>
              <vs-divider />
              <Grid
                :ref="'grid-permission'"
                :key="gridKey"
                :service="service"
                route_name="functionalities"
                order_column="name"
                :route_grid_path="permissionsFuncPath"
                :route_delete_path="permissionsFuncPath"
                hide_edit="true"
                :delegate="{destroy: () => destroyPermissionFunctionality}">
              </Grid>
              <div class="w-full flex gap-2 justify-end">
                <b-button
                  variant="outline-secondary"
                  class="float-right"
                  @click="goBack">
                  <feather-icon
                    icon="CornerUpLeftIcon"
                    class="mr-50"/>
                  <span class="align-middle">{{$t('back')}}</span>
                </b-button>
              </div>
            </div>
          </div>
          <permission-popup
            :visible="showPopupPermission"
            @selected="addPermissionsList"
            @close="closePopup"
            :filters="filtersGridPermission"/>

        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>

import standard from '@/services/standard'
import { isAdmin } from '@/util/Util'
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, max} from '@validations'
import SelectSuggestion from '@/components/SelectSuggestion.vue'

import FunctionalityService from '@/services/api/FunctionalityService'
import PermissionPopup from './../roles/PermissionPopup.vue'


export default {

  directives: {

  },
  components: {
    SelectSuggestion,
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver,
    // Custom
    SelectSuggestion,
    PermissionPopup
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    showPopupPermission: false,
    gridKey: 0,
    module: {
      id: null,
      name: ''
    },
    model: {
      id: null,
      name : '',
      module_id: null,
      description: ''
    }
  }),
  computed: {
    validateForm() {
      return !this.isEmpty(this.model.name)
            //&& !this.isEmpty(_.get(this.module, 'id'))
            //&& !this.isEmpty(this.model.description)
    },
    permissionsFuncPath() {
      return `/${this.id}/permissions`
    },
    filtersGridPermission() {
      //return [{key:'filter_not_in', value: 'functionalities'}, {key:'functionality_id', value: this.id}]
      return {
        filter_not_in : 'functionalities',
        functionality_id: this.id
      }
    }
  },
  beforeMount() {
    this.service = FunctionalityService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
          this.module = response.module
          this.gridKey++
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    createOrUpdate() {
      this.$vs.loading()

      const modelData = {
        id: this.id,
        name: this.model.name,
        module_id: _.get(this.module, 'id'),
        description: this.model.description,
      }

      this.service.createOrUpdate(modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.$router.push(`/functionalities/${data.id}/edit`)
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(
            this.$vs,
            this.$t('messages.error')
          )
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
    destroyPermissionFunctionality(item) {
      this.$vs.loading()
      this.service.destroyPermissionFunctionality(this.id, item.id).then(
        response => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Successo!',
            text: this.$t('messages.success'),
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
          })

          this.gridKey += 1
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, this.$t('messages.error'))
        }
      )
    },
    goBack() {
      this.$router.push('/functionalities')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    },
    addPermissionsList(permissionList = null) {
      if (permissionList && this._.isArray(permissionList) && permissionList.length > 0) {
        const permissions = []

        permissionList.forEach(
          (permission) => permissions.push(permission)
        )
        this.addPermissions(permissions)
      }
    },
    addPermissions(permissionIds) {
      this.$vs.loading()
      if (this.id) {
        this.service.addPermissions(this.id, permissionIds).then(
          response => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.updateGridPermissions()
          },
          error => {
            this.notifyError(this.$vs, 'Não foi possível adicionar a(s) permissião(ões)!')
          }
        ).finally(
          () => {
            this.$vs.loading.close()
          }
        )
      }
    },
    updateGridPermissions() {
      const gridRef = this.$refs['grid-permission']
      if (gridRef) {
        gridRef.fetchGridData()
      }
    },
    closePopup(show) {
      this.showPopupPermission = show
    }
  }
}
</script>

<style>

</style>
